<template>
  <v-app class="pa-2" v-show="!progress">
    <!-- ふきだし -->
    <v-container v-show="bubbleContent">
      <v-row>
        <v-col>
          <Bubble v-show="bubbleContent" :content="bubbleContent" />
        </v-col>
      </v-row>
    </v-container>

    <!-- カート内メニュー群 -->
    <v-container class="pt-0 pb-0" v-if="showCartContents">
      <v-row justify="center" v-for="(menu, i) in menus" :key="i">
        <v-col>
          <v-row align="center">
            <v-col cols="2" class="pa-0">
              <v-avatar size="60" tile>
                <ImgWrapper :src="menu.t_image_url" v-if="menu.t_image_url" />
                <ImgWrapper :src="noimageUrl" v-else />
              </v-avatar>
            </v-col>
            <v-col cols="7">
              <span
                v-if="isSoldOutMenu(menu)"
                class="text-h6 text-decoration-line-through"
              >
                {{ menu.name }}
              </span>
              <span v-else class="text-h6">{{ menu.name }} </span>
            </v-col>
            <v-col cols="3" class="pt-0 pb-0" align="right">
              <span class="text-subtitle-1"
                >￥{{ menu.amountBaseEx | addComma }}</span
              >
            </v-col>
          </v-row>
          <v-row
            v-for="(topping, j) in toppingsData(menu.toppings)"
            :key="j"
            align="center"
          >
            <v-spacer cols="2" />
            <v-col cols="7" class="pt-0 pb-0">
              <span
                v-if="isSoldOutToppingValue(topping)"
                class="text-subtitle-2 text-decoration-line-through"
                >{{ topping.title }} ({{ topping.name }})
              </span>
              <span v-else class="text-subtitle-2"
                >{{ topping.title }} ({{ topping.name }})
              </span>
            </v-col>
            <v-col cols="3" class="pt-0 pb-0" align="right">
              <span class="text-subtitle-1"
                >￥{{ topping.amount | addComma }}</span
              >
            </v-col>
          </v-row>
          <v-row align="center">
            <v-spacer />
            <v-col cols="7" class="pt-0 pb-0">
              <span class="text-subtitle-2">数量</span>
            </v-col>
            <v-col cols="3" class="pt-0 pb-0" align="right">
              <span class="text-subtitle-1">{{ menu.count }}</span>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-spacer />
            <v-col cols="5" class="text-h5" align="right">
              ￥{{ amountMenu(menu) | addComma }}
            </v-col>
          </v-row>
          <v-row align="center">
            <v-spacer cols="2" />
            <v-col cols="3" v-show="isSoldOutItem(menu)">
              <span class="text-h6 red--text">完売</span>
            </v-col>
            <v-col cols="7" align="right">
              <v-btn
                medium
                tile
                color="#707070"
                class="ma-2 white--text text-button"
                @click="deleteMenu(menu)"
                >削除</v-btn
              >
              <v-btn
                medium
                tile
                text
                outlined
                class="text-button"
                @click="changeMenu(menu)"
                >変更</v-btn
              >
            </v-col>
          </v-row>
          <v-divider class="mt-2" />
        </v-col>
      </v-row>
    </v-container>

    <!-- 金額 -->
    <v-container v-if="showCartContents && menus.length != 0" class="pt-0 pr-8">
      <!-- <v-row justify="end" class="pt-0" align="baseline">
        <v-col cols="4">
          <span class="text-h5">合計</span>
        </v-col>
        <v-col cols="8" class="pr-0" align="right">
          <span class="text-h4">￥</span
          ><span class="text-h3">{{ amountCart(menus) | addComma }}</span>
        </v-col>
      </v-row> -->
      <v-row justify="end" class="pt-0" align="baseline">
        <v-col cols="4">
          <span class="text-h5">合計</span>
        </v-col>
        <v-col cols="8" class="pr-0" align="right">
          <span class="text-h4">￥</span
          ><span class="text-h3">{{ totalData.prices | addComma }}</span>
        </v-col>
      </v-row>
      <v-row justify="end" v-show="totalData.pricesTax10 > 0">
        <v-col cols="auto" class="pt-0 pr-0">
          <span class="text-h7">( 10%対象 ￥</span>
          <span class="text-h7">{{ totalData.pricesTax10 }}</span>
          <span class="text-h7"> )</span>
        </v-col>
      </v-row>
      <v-row justify="end" v-show="totalData.pricesTax8 > 0">
        <v-col cols="auto" class="pt-0 pr-0">
          <span class="text-h7">( 8%軽減対象 ￥</span>
          <span class="text-h7">{{ totalData.pricesTax8 | addComma }}</span>
          <span class="text-h7"> )</span>
        </v-col>
      </v-row>
      <v-row justify="end">
        <v-col cols="auto" class="pt-0 pr-0">
          <span class="text-h7">( 内消費税等 ￥</span>
          <span class="text-h7">{{ totalData.taxTotal | addComma }}</span>
          <span class="text-h7"> )</span>
        </v-col>
      </v-row>
    </v-container>

    <!-- ボタン -->
    <v-container>
      <v-row>
        <v-col>
          <v-btn
            v-show="showButtonArea"
            x-large
            block
            tile
            text
            outlined
            @click="addOrder"
          >
            注文を追加する
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
            v-show="showButtonArea && menus.length != 0"
            x-large
            block
            tile
            color="primary"
            :disabled="!nextEnabled"
            @click="next"
          >
            この内容で次へすすむ
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <!-- sheet(注文追加) -->
    <v-bottom-sheet v-model="showAddOrderSheet">
      <v-sheet class="text-center">
        <v-container class="line-bg">
          <v-row>
            <v-col>
              <Bubble
                question="注文を追加する"
                content="どちらから追加しますか？"
                :border-content="false"
              />
            </v-col>
          </v-row>

          <div class="mt-8 mb-4">
            <QuickReply
              text="メニューから"
              class="ma-2"
              :click="onClickToMenu"
            />
            <QuickReply text="注文履歴から" :click="onClickToOrderHistory" />
          </div>
          <!-- 下部固定 -->
          <div style="align: center; width: 100%">
            <v-btn x-large text @click="showAddOrderSheet = !showAddOrderSheet"
              ><span class="text-decoration-underline white--text"
                >カートへもどる</span
              ></v-btn
            >
          </div>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>

    <!-- sheet エラー(共通) -->
    <v-bottom-sheet v-model="showErrorCmnSheet">
      <v-sheet class="text-center">
        <v-container class="line-bg">
          <v-row>
            <v-col>
              <Bubble
                v-show="errorSheetCmnText"
                question=""
                :content="errorSheetCmnText"
                :border-content="false"
              />
            </v-col>
          </v-row>

          <!-- 下部固定 -->
          <div style="align: center; width: 100%">
            <v-btn x-large text @click="showErrorCmnSheet = !showErrorCmnSheet"
              ><span class="text-decoration-underline white--text"
                >カートへもどる</span
              ></v-btn
            >
          </div>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>

    <!-- sheet エラー(再表示) -->
    <v-bottom-sheet v-model="showSheetReload" persistent>
      <v-sheet class="text-center">
        <v-container class="line-bg">
          <v-row>
            <v-col>
              <Bubble
                v-show="errorSheetReloadText"
                :content="errorSheetReloadText"
                :border-content="false"
              />
            </v-col>
          </v-row>
          <div class="mt-8 mb-8">
            <QuickReply
              text="再表示する"
              class="ma-2"
              :click="onClickToReload"
            />
          </div>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>

    <!-- snackbar -->
    <v-snackbar v-model="snackbar" :timeout="timeout" :multi-line="true">
      {{ snackbarText }}
    </v-snackbar>
  </v-app>
</template>

<script>
import liff from "@line/liff";
import { mapGetters, mapActions } from "vuex";
import { MSG_TYPE, commonError } from "../components/error/errorConstants";
import Bubble from "./parts/Bubble";
import QuickReply from "./parts/QuickReply";
import { calculate } from "../util/calculate";
import { MSG_CART } from "../constants/messages";

import {
  CHECK_TYPE,
  createCheckErrMsg,
  isOrderDisabledCartMenu,
  isOrderDisabledMenu,
  isOrderDisabledValue,
  CART_ITEM,
} from "../util/order_util";
const IMAGE_DEFAULT = require("@/assets/noimage.png");

// エラーシート
const SHEET_ERR_CMN = 0;
const SHEET_ERR_RELOAD = 1;

export default {
  components: {
    Bubble,
    QuickReply,
    ImgWrapper: () => import("./parts/ImgWrapper"),
  },
  data: () => ({
    noimageUrl: IMAGE_DEFAULT,
    bubbleContent: "",
    showCartContents: false, // カート内メニューを表示するかどうか
    menus: [], // 表示用 (cartData 更新のたびに再設定)
    showButtonArea: false,
    nextEnabled: false,
    // show
    viewData: [],
    totalData: {
      prices: 0,
      pricesTax10: 0,
      pricesTax8: 0,
    },
    // bottom sheet
    showAddOrderSheet: false,
    showErrorCmnSheet: false,
    errorSheetCmnText: "",
    showSheetReload: false,
    errorSheetReloadText: "",
    // snackbar
    snackbar: false,
    timeout: 2000,
    snackbarText: "",
  }),
  created() {
    this.$store.state.appBar = true;
    this.$store.state.title = "カート";
    this.$store.state.cart = false;
  },
  async mounted() {
    await liff.ready; // LIFF 初期化待機
    this.showProgress();

    try {
      await this.refreshView();
    } catch (error) {
      console.log(error);
      const msgType = MSG_TYPE.LOAD;
      this.$router.replace({ name: "Error", query: { msgType: msgType } });
    } finally {
      this.hideProgress();
    }
  },
  computed: {
    ...mapGetters(["progress", "cartViewData"]),
    toppingsData: function () {
      return function (toppings) {
        return this.createToppingsViewData(toppings);
      };
    },
    amountMenu: function () {
      return function (menu) {
        return this.calculateMenuAmount(menu);
      };
    },
    amountCart: function () {
      return function (menus) {
        return this.calculateMenuAmountTotal(menus);
      };
    },
  },
  watch: {
    cartViewData: function () {
      if (!this.cartViewData) {
        return;
      }
      this.bindCart();
    },
  },
  methods: {
    ...mapActions([
      "showProgress",
      "hideProgress",
      "fetchCartData",
      "checkBeforeMenuAction",
      "checkBeforeAddAction",
      "checkBeforeNextAction",
    ]),
    ...mapActions("rest", [
      "updateCartId",
      "deleteCartMenu",
      "deleteCartMenusByMstChanged",
    ]),
    refreshView: async function () {
      this.menus = [];
      return this.fetchData();
    },
    fetchData: async function () {
      // カートデータ取得
      return this.fetchCartData();
    },
    bindCart: function () {
      const cartData = this.cartViewData.cartData;
      const menus = cartData.menus ?? [];
      this.menus = menus;
      console.log("bindCart", menus);

      // カートが空の場合
      if (!menus || menus.length == 0) {
        this.showEmptyBubbleContent();
        this.showButtonArea = true;
        return;
      }

      const bubble = this.cartViewData.bubble;
      const taxSettings = this.cartViewData.taxSettings;
      const cartCheckResult = this.cartViewData.cartCheckResult;
      console.log("bindCart", bubble, taxSettings, cartCheckResult);

      // ふきだし
      if (cartCheckResult === CART_ITEM.OK) {
        this.showOkBubbleContent(bubble);
      } else {
        this.showNgBubbleContent(cartCheckResult);
      }

      // シート表示 (再読込)
      if (
        cartCheckResult === CART_ITEM.UPDATED ||
        cartCheckResult === CART_ITEM.DELETED
      ) {
        this.showSheetReload = true;
        this.errorSheetReloadText = MSG_CART.CHANGED;
        // カート内メニューを表示しない
        this.showCartContents = false;
        this.showButtonArea = false;
        return;
      }

      // 「この内容で次へすすむ」押下可能かどうか
      this.nextEnabled = cartCheckResult === CART_ITEM.OK;

      // 合計金額
      this.totalData = calculate.createTotalData(taxSettings, menus);
      console.log("totalData", this.totalData);

      // カート内メニューを表示許可
      this.showCartContents = true;
      this.showButtonArea = true;
    },
    /**
     * 編集 押下
     */
    changeMenu: async function (menu) {
      this.showProgress();
      try {
        return this.changeMenuProcess(menu);
      } catch (error) {
        console.log(error);
        const msg = commonError.findMessage(MSG_TYPE.SHEET_LOAD).text;
        this.showErrorSheet(SHEET_ERR_CMN, msg);
      } finally {
        this.hideProgress();
      }
    },
    changeMenuProcess: async function (menu) {
      // 遷移前チェック
      const beforeCheckResult = await this.checkBeforeMenuAction({
        menu,
        rest: true,
      });
      if (!beforeCheckResult.result) {
        const checkType = beforeCheckResult.type;
        const sheetType = this.getErrorSheetType(checkType);
        const msg = createCheckErrMsg(checkType);
        this.showErrorSheet(sheetType, msg);
        return;
      }

      // 画面遷移(該当メニュー)
      const path = {
        name: "Menu",
        params: { id: menu.menuId },
        query: { from: "cart", cartMenuId: menu.cartMenuId },
      };
      this.$router.push(path);
    },
    /**
     * 削除 押下
     */
    deleteMenu: async function (menu) {
      this.showProgress();
      try {
        await this.deleteMenuProcess(menu);
      } catch (error) {
        console.log(error);
        const msg = commonError.findMessage(MSG_TYPE.SHEET_UPDATE).text;
        this.showErrorSheet(SHEET_ERR_CMN, msg);
      } finally {
        this.hideProgress();
      }
    },
    deleteMenuProcess: async function (menu) {
      // 遷移前チェック
      const beforeCheckResult = await this.checkBeforeMenuAction({
        menu,
        rest: true,
      });
      if (!beforeCheckResult.result) {
        const checkType = beforeCheckResult.type;
        const sheetType = this.getErrorSheetType(checkType);
        const msg = createCheckErrMsg(checkType);
        this.showErrorSheet(sheetType, msg);
        return;
      }

      // カートデータ削除 (物理)
      await this.deleteCartMenu({ menu });

      // 再描画
      console.log("reload(currentRoute)", this.$router.currentRoute);
      return this.refreshView();
    },
    showEmptyBubbleContent: function () {
      const content = "カートは空です";
      this.bubbleContent = `${content}`;
    },
    showOkBubbleContent: function (bubble) {
      let content = "";
      const serverContent = bubble ? bubble.cart : "";
      if (serverContent) {
        content = serverContent;
      } else {
        content = `ご注文は以上でよろしいですか？`;
      }
      this.bubbleContent = `${content}`;
      return content;
    },
    showNgBubbleContent: function (cartCheckResult) {
      let content = "";
      if (cartCheckResult === CART_ITEM.SOLDOUT) {
        content =
          "注文できない商品が含まれています。カートを修正してください。";
      } else if (
        cartCheckResult === CART_ITEM.UPDATED ||
        cartCheckResult === CART_ITEM.DELETED
      ) {
        // ふきだしは何も表示しない
        // sheet 側でエラー表示する
        return;
      } else {
        throw Error(`not implemented: ${cartCheckResult}`);
      }
      this.bubbleContent = `${content}`;
      return content;
    },
    createToppingsViewData: function (toppings) {
      // 表示用に加工
      var viewData = [];

      // selected されているトッピングのみ羅列する
      toppings?.forEach((topping) => {
        const selected = topping.selected;
        topping.values
          .filter((value) => value.id == selected)
          .forEach((value) => {
            value.title = topping.name;
            viewData.push(value);
          });
      });

      return viewData;
    },
    isSoldOutItem: function (menu) {
      console.log("@isSoldOutItem", menu);
      // 売切を含むかどうか (メニュー/選択肢含めて)
      return isOrderDisabledCartMenu(menu);
    },
    isSoldOutMenu: function (menu) {
      // 売切かどうか (メニュー単体)
      return isOrderDisabledMenu(menu);
    },
    isSoldOutToppingValue: function (toppingValue) {
      // 売切かどうか (選択肢単体)
      return isOrderDisabledValue(toppingValue);
    },
    addOrder: async function () {
      this.showProgress();
      try {
        await this.addOrderProcess();
      } catch (error) {
        console.log(error);
        const msg = commonError.findMessage(MSG_TYPE.SHEET_LOAD).text;
        this.showErrorSheet(SHEET_ERR_CMN, msg);
      } finally {
        this.hideProgress();
      }
    },
    addOrderProcess: async function () {
      console.log("addOrder");

      // 事前チェック
      const checkResult = await this.checkBeforeAddAction();
      if (!checkResult.result) {
        const checkType = checkResult.type;
        const sheetType = this.getErrorSheetType(checkType);
        const msg = createCheckErrMsg(checkType);
        this.showErrorSheet(sheetType, msg);
        return;
      }

      // シート表示(注文追加)
      this.showAddOrderSheet = !this.showAddOrderSheet;
    },
    next: async function () {
      try {
        this.showProgress();
        await this.nextProcess();
      } catch (error) {
        console.log(error);
        const msg = commonError.findMessage(MSG_TYPE.SHEET_UPDATE).text;
        this.showErrorSheet(SHEET_ERR_CMN, msg);
      } finally {
        this.hideProgress();
      }
    },
    nextProcess: async function () {
      // 事前チェック
      const beforeCheckResult = await this.checkBeforeNextAction();
      if (!beforeCheckResult.result) {
        const checkType = beforeCheckResult.type;
        const sheetType = this.getErrorSheetType(checkType);
        const msg = createCheckErrMsg(checkType);
        this.showErrorSheet(sheetType, msg);
        return;
      }

      // カートID 更新
      const newCartId = await this.updateCartId();

      // 画面遷移 (注文の流れ)
      this.$router.push({
        name: "OrderStep",
        query: { cartId: newCartId },
      });
    },

    calculateMenuAmount: function (menu) {
      return calculate.calcMenuPrice(menu);
    },
    calculateMenuAmountTotal: function (menus) {
      const total = menus.reduce((sum, menu) => {
        return sum + this.calculateMenuAmount(menu);
      }, 0);
      return total;
    },
    onClickToMenu: async function () {
      this.$router.push({ name: "MenuList" });
    },
    onClickToOrderHistory: function () {
      this.$router.push({ name: "OrderHistoryList" });
    },
    onClickToReload: async function () {
      this.showProgress();
      try {
        // カート内アイテム削除
        await this.deleteCartMenusByMstChanged();

        // 再描画
        return this.refreshView();
      } catch (error) {
        console.log(error);
        const msg = commonError.findMessage(MSG_TYPE.SHEET_LOAD).text;
        this.showErrorSheet(SHEET_ERR_CMN, msg);
      } finally {
        this.showSheetReload = false;
        this.hideProgress();
      }
    },
    showErrorSheet: function (type, msg) {
      switch (type) {
        case SHEET_ERR_CMN:
        default:
          this.errorSheetCmnText = msg;
          this.showErrorCmnSheet = !this.showErrorCmnSheet;
          break;
        case SHEET_ERR_RELOAD:
          this.errorSheetReloadText = msg;
          this.showSheetReload = !this.showSheetReload;
          break;
      }
    },
    getErrorSheetType: function (checkType) {
      switch (checkType) {
        case CHECK_TYPE.MST_MENU_CHANGED:
        case CHECK_TYPE.MST_MENU_DELETED:
          return SHEET_ERR_RELOAD;
        default:
          return SHEET_ERR_CMN;
      }
    },
  },
};
</script>

<style scoped>
@import "../css/bubble.css";
</style>
